import React, { useState, useEffect } from "react";
import Layout from "../pages/Layout";
import Advertise from "../pages/Advertise";

const WeddingBudget = () => {
  // State variables for Wedding Budget calculation
  const [venue, setVenue] = useState(0); // Venue cost
  const [catering, setCatering] = useState(0); // Catering cost
  const [attire, setAttire] = useState(0); // Attire cost
  const [decorations, setDecorations] = useState(0); // Decorations cost
  const [photography, setPhotography] = useState(0); // Photography cost
  const [miscellaneous, setMiscellaneous] = useState(0); // Miscellaneous cost
  const [totalCost, setTotalCost] = useState(0); // Total wedding cost

  // Event handlers to update state values
  const handleVenueChange = (e) => setVenue(parseFloat(e.target.value) || 0);
  const handleCateringChange = (e) =>
    setCatering(parseFloat(e.target.value) || 0);
  const handleAttireChange = (e) => setAttire(parseFloat(e.target.value) || 0);
  const handleDecorationsChange = (e) =>
    setDecorations(parseFloat(e.target.value) || 0);
  const handlePhotographyChange = (e) =>
    setPhotography(parseFloat(e.target.value) || 0);
  const handleMiscellaneousChange = (e) =>
    setMiscellaneous(parseFloat(e.target.value) || 0);

  // useEffect hook to calculate total wedding cost when any input changes
  useEffect(() => {
    const totalWeddingCost =
      venue + catering + attire + decorations + photography + miscellaneous;
    setTotalCost(totalWeddingCost);

     // This will initialize or reinitialize all popovers on the page whenever the component renders
     const popoverTriggerList = [].slice.call(
      document.querySelectorAll('[data-bs-toggle="popover"]')
    );

    // Clean up any existing popover instances
    popoverTriggerList.forEach((popoverTriggerEl) => {
      const popover = window.bootstrap.Popover.getInstance(popoverTriggerEl); // Check if instance already exists
      if (popover) {
        popover.dispose(); // Dispose of existing popover
      }
    });

    // Re-initialize popovers
    popoverTriggerList.forEach((popoverTriggerEl) => {
      new window.bootstrap.Popover(popoverTriggerEl); // Re-initialize popovers
    });


  }, [venue, catering, attire, decorations, photography, miscellaneous]);

  return (
    <Layout title="Wedding Budget Calculator" path="wedding-budget">
      <section className="section-padding" id="wedding-budget-calculator">
        <div className="container mt-5">
          <div className="row">
            {/* Wedding Budget Calculator Form */}
            <div className="col-lg-9 col-md-8 mb-4">
              <div
                className="p-4 border rounded shadow"
                style={{ border: "1px solid black" }}
              >
                <h3 className="text-center mb-4">Wedding Budget Calculator</h3>
                <div className="container">
                  <div className="row gy-3">
                    {/* Venue Input */}
                    <div className="col-md-6 col-lg-4">
                      <label htmlFor="venue" className="form-label">
                        Venue (₹)
                        <span
                          className="ms-2 text-muted"
                          data-bs-toggle="popover"
                          data-bs-html="true"
                          data-bs-placement="top"
                          data-bs-content="<strong>Venue:</strong> The cost of renting the location for the wedding event, including any venue services like setup and cleaning."
                          style={{ cursor: "pointer" }}
                        >
                          <i className="bi bi-info-circle"></i>
                        </span>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="venue"
                        placeholder="Enter venue cost"
                        value={venue || ""}
                        onChange={handleVenueChange}
                      />
                    </div>

                    {/* Catering Input */}
                    <div className="col-md-6 col-lg-4">
                      <label htmlFor="catering" className="form-label">
                        Catering (₹)
                        <span
                          className="ms-2 text-muted"
                          data-bs-toggle="popover"
                          data-bs-html="true"
                          data-bs-placement="top"
                          data-bs-content="<strong>Catering:</strong> The cost of food and beverages provided for the wedding guests."
                          style={{ cursor: "pointer" }}
                        >
                          <i className="bi bi-info-circle"></i>
                        </span>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="catering"
                        placeholder="Enter catering cost"
                        value={catering || ""}
                        onChange={handleCateringChange}
                      />
                    </div>

                    {/* Attire Input */}
                    <div className="col-md-6 col-lg-4">
                      <label htmlFor="attire" className="form-label">
                        Attire (₹)
                        <span
                          className="ms-2 text-muted"
                          data-bs-toggle="popover"
                          data-bs-html="true"
                          data-bs-placement="top"
                          data-bs-content="<strong>Attire:</strong> The cost of clothing, including the bride's and groom's outfits, bridesmaids' dresses, groomsmen's suits, etc."
                          style={{ cursor: "pointer" }}
                        >
                          <i className="bi bi-info-circle"></i>
                        </span>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="attire"
                        placeholder="Enter attire cost"
                        value={attire || ""}
                        onChange={handleAttireChange}
                      />
                    </div>

                    {/* Decorations Input */}
                    <div className="col-md-6 col-lg-4">
                      <label htmlFor="decorations" className="form-label">
                        Decorations (₹)
                        <span
                          className="ms-2 text-muted"
                          data-bs-toggle="popover"
                          data-bs-html="true"
                          data-bs-placement="top"
                          data-bs-content="<strong>Decorations:</strong> The cost of floral arrangements, lighting, drapes, and any other decor for the wedding venue."
                          style={{ cursor: "pointer" }}
                        >
                          <i className="bi bi-info-circle"></i>
                        </span>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="decorations"
                        placeholder="Enter decorations cost"
                        value={decorations || ""}
                        onChange={handleDecorationsChange}
                      />
                    </div>

                    {/* Photography Input */}
                    <div className="col-md-6 col-lg-4">
                      <label htmlFor="photography" className="form-label">
                        Photography (₹)
                        <span
                          className="ms-2 text-muted"
                          data-bs-toggle="popover"
                          data-bs-html="true"
                          data-bs-placement="top"
                          data-bs-content="<strong>Photography:</strong> The cost of hiring a photographer to capture the wedding ceremony, reception, and other moments."
                          style={{ cursor: "pointer" }}
                        >
                          <i className="bi bi-info-circle"></i>
                        </span>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="photography"
                        placeholder="Enter photography cost"
                        value={photography || ""}
                        onChange={handlePhotographyChange}
                      />
                    </div>

                    {/* Miscellaneous Input */}
                    <div className="col-md-6 col-lg-4">
                      <label htmlFor="miscellaneous" className="form-label">
                        Miscellaneous (₹)
                        <span
                          className="ms-2 text-muted"
                          data-bs-toggle="popover"
                          data-bs-html="true"
                          data-bs-placement="top"
                          data-bs-content="<strong>Miscellaneous:</strong> Any other costs not covered in the above categories, such as transportation, wedding favors, or officiant fees."
                          style={{ cursor: "pointer" }}
                        >
                          <i className="bi bi-info-circle"></i>
                        </span>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="miscellaneous"
                        placeholder="Enter miscellaneous cost"
                        value={miscellaneous || ""}
                        onChange={handleMiscellaneousChange}
                      />
                    </div>
                  </div>

                  {/* Result Section */}
                  <div className="mt-4">
                    <div className="p-3 text-center">
                      <h6>
                        Total Wedding Cost:{" "}
                        <span className="fw-bold ms-3">
                          {totalCost === 0
                            ? "0.00"
                            : totalCost.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}{" "}
                          ₹
                        </span>
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Advertisement Section */}
            <Advertise />
          </div>
        </div>
      </section>

      {/* Introduction Section */}
      <section className="introduction-section" id="introduction">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="p-5">
                <h3 className="text-center mb-5">
                  Introduction to the Wedding Budget Calculator
                </h3>

                {/* What is a Wedding Budget Calculator? */}
                <h4 className="mt-3 mb-3">
                  What is a Wedding Budget Calculator?
                </h4>
                <p>
                  A **Wedding Budget Calculator** helps couples and wedding
                  planners estimate the total expenses involved in planning a
                  wedding. It considers various categories such as venue,
                  catering, attire, decorations, photography, and other
                  miscellaneous costs.
                </p>

                {/* Why Use a Wedding Budget Calculator? */}
                <h4 className="mt-4 mb-3">
                  Why Use a Wedding Budget Calculator?
                </h4>
                <p>
                  This calculator is essential for couples to stay on track with
                  their wedding expenses, ensuring that they do not exceed their
                  budget. It also helps wedding planners provide more accurate
                  cost estimates for clients.
                </p>

                {/* Benefits of Using a Wedding Budget Calculator */}
                <h4 className="mt-4 mb-3">
                  Benefits of Using a Wedding Budget Calculator
                </h4>
                <ul>
                  <li>
                    <strong>Helps Couples Plan and Stay Within Budget:</strong>{" "}
                    Couples can ensure they allocate enough funds for each
                    aspect of their wedding without overspending.
                  </li>
                  <li>
                    <strong>Reduces the Risk of Overspending:</strong> The
                    calculator helps in making sure the total costs do not
                    exceed the available budget.
                  </li>
                  <li>
                    <strong>
                      Provides Transparency for Wedding-Related Expenses:
                    </strong>{" "}
                    Ensures a clear breakdown of all costs involved in the
                    wedding planning process.
                  </li>
                </ul>

                {/* Suitable For */}
                <h4 className="mt-4 mb-3">
                  Who Should Use a Wedding Budget Calculator?
                </h4>
                <p>The Wedding Budget Calculator is suitable for:</p>
                <ul>
                  <li>
                    <strong>Event Planners:</strong> Helps in organizing wedding
                    expenses for clients.
                  </li>
                  <li>
                    <strong>Couples Planning Their Wedding:</strong> Ensures
                    that all wedding-related costs are accounted for and
                    budgeted accordingly.
                  </li>
                  <li>
                    <strong>Wedding Planners:</strong> Professionals can use
                    this tool to provide clients with an accurate budget
                    breakdown for their weddings.
                  </li>
                </ul>

                {/* Additional Questions */}
                <h4 className="mt-4 mb-3">
                  How can I reduce my wedding expenses?
                </h4>
                <p>
                  To reduce wedding expenses, consider adjusting your choices in
                  venue, catering, or decorations. Opting for a smaller guest
                  list, DIY decorations, and negotiating with vendors can also
                  help cut down costs.
                </p>

                <h4 className="mt-4 mb-3">
                  What is the average cost of a wedding?
                </h4>
                <p>
                  The average wedding cost can vary depending on location,
                  number of guests, and preferences. However, weddings can
                  typically range from ₹50,000 to several lakhs.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default WeddingBudget;
